// src/components/ReadOnlyStars.jsx
import React from 'react';

// Simple read-only 5-star display (supports halves)
export default function ReadOnlyStars({ value, size = 18, ariaLabel, color = '#333333' /* violet-600 */ }) {
  const v = Math.max(0, Math.min(5, Number(value ?? 0)));
  const full = Math.floor(v);
  const frac = v - full;
  const hasHalf = frac >= 0.25 && frac < 0.75;
  const plusFull = frac >= 0.75 ? 1 : 0;

  const stars = [];
  for (let i = 0; i < 5; i++) {
    let ch = '☆';
    if (i < full + plusFull) ch = '★';
    else if (i === full && hasHalf) ch = '⯨'; // half-ish fallback glyph
    stars.push(
      <span key={i} style={{ fontSize: size, lineHeight: 1 }} aria-hidden="true">
        {ch}
      </span>
    );
  }

  return (
    <span style={{ color }} aria-label={ariaLabel} title={ariaLabel}>
      {stars}
    </span>
  );
}
